module.exports = __webpack_public_path__ + "img/symbol_18_normal.23c2a885.png";